import React, { useState, useEffect } from "react";
import "./ScrollToTopButton.css";
import { ArrowBigDown, ArrowBigUp, ArrowUp } from "lucide-react";

export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      className={`scroll-top-btn ${isVisible ? "show" : ""}`}
      onClick={scrollToTop}
    >
      <ArrowUp />
    </button>
  );
}
